import React from 'react';
import {render} from 'react-dom';
import {BrowserRouter, Routes, Route, Navigate, useLocation} from 'react-router-dom';
import appConfig from '../config/config';
// Add regenaratorRuntime available globally, this is needed since contentful-management v7
import 'regenerator-runtime/runtime.js';
import App from './components/no/motorgruppen/main';
import CampaignContainer from './components/no/motorgruppen/campaign/CampaignContainer';
import CampaignsContainer from './components/no/motorgruppen/campaigns/CampaignsContainer';
import CarConfigurator from './components/no/motorgruppen/carconfigurator/CarConfigurator';
import ColorContainer from './components/no/motorgruppen/newcarinformation/ColorContainer';
import DealerContainer from './components/no/motorgruppen/dealer/DealerContainer';
import DealerEmployeeEditContainer from './components/no/motorgruppen/dealer/DealerEmployeeEditContainer.js';
import DealerRegister from './components/no/motorgruppen/dealerregister/DealerRegister';
import MakesRegister from './components/no/motorgruppen/makes/MakesRegister';
import MakeContainer from './components/no/motorgruppen/makes/MakeContainer';
import EquipmentLevelContainer from './components/no/motorgruppen/equipmentlevel/EquipmentLevelContainer';
import EquipmentContainer from './components/no/motorgruppen/equipment/EquipmentContainer';
import EquipmentFactoryContainer from './components/no/motorgruppen/equipmentFactory/EquipmentFactoryContainer';
import EquipmentGroupContainer from './components/no/motorgruppen/equipmentGroup/EquipmentGroupContainer';
import OpenGraphContainer from './components/no/motorgruppen/OpenGraph/OpenGraphContainer';
import OpenGraphList from './components/no/motorgruppen/OpenGraph/OpenGraphList';
import LeaseContainer from './components/no/motorgruppen/Lease/LeaseContainer';
import LeaseList from './components/no/motorgruppen/Lease/LeaseList';
import Lead from './components/no/motorgruppen/leads/Lead';
import LeadsTesting from './components/no/motorgruppen/leads/LeadsTesting';
import LeadsList from './components/no/motorgruppen/leads/LeadsList';
import ReservationsList from './components/no/motorgruppen/reservations/ReservationsList';
import Reservation from './components/no/motorgruppen/reservations/Reservation';
import CarInformation from './components/no/motorgruppen/generation/CarInformation';
import Generations from './components/no/motorgruppen/generation/Generations';
import GenerationModels from './components/no/motorgruppen/generation/Models';
import GenerationsContainer from './components/no/motorgruppen/generation/GenerationContainer';
import ArticleContainer from './components/no/motorgruppen/article/ArticleContainer';
import ArticlesContainer from './components/no/motorgruppen/articles/ArticlesContainer';
import MotorforumArticleContainer from './components/no/motorgruppen/motorforum/article/ArticleContainer';
import MotorforumArticlesContainer from './components/no/motorgruppen/motorforum/articles/ArticlesContainer';
import MotorforumCampaignOverridesOverview from './components/no/motorgruppen/motorforum/campaignOverrides/CampaignOverridesOverview';
import MotorforumCampaignOverride from './components/no/motorgruppen/motorforum/campaignOverrides/CampaignOverrideContainer';
import NewCarInformation from './components/no/motorgruppen/newcarinformation/NewCarInformation';
import GiftcardContainer from './components/no/motorgruppen/giftcard/GiftcardContainer';
import GiftcardsList from './components/no/motorgruppen/giftcard/GiftcardsList';
import Models from './components/no/motorgruppen/newcarinformation/Models';
import ModelContainer from './components/no/motorgruppen/newcarinformation/ModelContainer';
import ModelPageContainer from './components/no/motorgruppen/newcarinformation/ModelPageContainer';
import StockList from './components/no/motorgruppen/stock/StockList';
import StockCarContainer from './components/no/motorgruppen/stock/StockCarContainer';
import SystemContainer from './components/no/motorgruppen/system/SystemContainer';
import VariantContainer from './components/no/motorgruppen/newcarinformation/VariantContainer';
import VariantGroupContainer from './components/no/motorgruppen/newcarinformation/VariantGroupContainer';
import WarrantyDocsContainer from './components/no/motorgruppen/warrantyDocs/WarrantyDocsContainer';
import WarrantyDocsList from './components/no/motorgruppen/warrantyDocs/WarrantyDocsList';
import mypageAccess from './components/no/motorgruppen/mypageAccess/MypageAccessContainer';
import WarrantyPeriodList from './components/no/motorgruppen/warrantyPeriod/WarrantyPeriodList';
import WarrantyPeriodContainer from './components/no/motorgruppen/warrantyPeriod/WarrantyPeriodContainer';
import WarrantyPeriodTester from './components/no/motorgruppen/warrantyPeriod/WarrantyPeriodTester';
import LeadSchemasContainer from './components/no/motorgruppen/leadSchemas/LeadSchemasContainer';
import LeadSchemaContainer from './components/no/motorgruppen/leadSchema/LeadSchemaContainer';
import AuthService from './components/no/motorgruppen/auth/AuthService';
import fetchIntercept from 'fetch-intercept';
import _ from 'lodash';
import MediaBrowserList from './components/no/motorgruppen/mediaBrowser/MediaBrowserList';
import MediaContainer from './components/no/motorgruppen/mediaBrowser/MediaContainer';
import {TagProvider} from './providers/TagsProvider';

/* Set up services */
const authService = new AuthService(appConfig.auth);

const AuthedRoute = ({Component}) => {
  const location = useLocation();

  // Set a default title on all route changes.
  // So that a title set in a component will not show on a wrong page
  document.title = 'Motorgruppen Admin';
  React.useEffect(() => {
    // window.scrollTo({top: 0, left: 0});
  }, [location]);

  if (!authService.authenticated()) {
    authService.revokeAuthentication();
    return <Navigate to={{
      pathname: '/',
      search: `?login&redirect=${encodeURIComponent(location.pathname)}`
    }} />;
  }

  // Route authorization
  const routes = location.pathname.split('/');
  if (routes && routes.length > 1) {
    if (!authService.isAuthorized(routes[1])) {
      window.console.error('Not authorized', routes[1]);
      return <Navigate to={{
        pathname: '/'
      }} />;
    }
  }

  return <Component />;
};

/* Set up interceptors */

// JWT interceptor
fetchIntercept.register({
  request: function (url, config) {
    const servicesBaseUrl = `${appConfig.services.MG_PROTOCOL}://${appConfig.services.MG_DOMAIN}:${appConfig.services.MG_PORT}${appConfig.services.MG_SERVICES_BASE}`;
    const taskQueueBaseUrl = `${appConfig.taskQueue.protocol}://${appConfig.taskQueue.hostname}:${appConfig.taskQueue.port}${appConfig.taskQueue.pathname}`;

    const isLeadsRequest = url.indexOf(servicesBaseUrl) > -1;
    const isQueueRequest = url.indexOf(taskQueueBaseUrl) > -1;

    // Add authorization header if user is authenticated and this is a request
    // to the "services" API or the "taskQueue" API:
    if (authService.authenticated() && (isLeadsRequest || isQueueRequest)) {
      // Get roles token
      let motorgruppenRoles = '';
      const userProfile = authService.getUserProfile();
      if (userProfile.app_metadata) {
        if (userProfile.app_metadata.roles_token) {
          motorgruppenRoles = userProfile.app_metadata.roles_token;
        }
      }

      // Insert JWT
      config = _.merge(config, {
        mode: 'cors',
        headers: {
          'Authorization': `Bearer ${authService.getToken()}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-motorgruppen-roles': motorgruppenRoles
        }
      });
    } else {
      config = _.merge(config, {
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    }
    return [url, config];
  }
});

render((
  <BrowserRouter>
    <div>
      <div className="wrapper">
        <App authService={authService} />
        <div id="page-wrapper">
          <TagProvider>
            <Routes>
              <Route path="/" element />
              <Route path="/ansatt/:employeeId" element={<AuthedRoute Component={DealerEmployeeEditContainer} />} />
              <Route path="/ansatt/new/:dealerId" element={<AuthedRoute Component={DealerEmployeeEditContainer} />} />
              <Route path="/equipmentlevel/:eqipmentlevelid" element={<AuthedRoute Component={EquipmentLevelContainer} />} />
              <Route path="/equipmentlevel/:eqipmentlevelid/:modelId" element={<AuthedRoute Component={EquipmentLevelContainer} />} />
              <Route path="/equipment/:equipmentid" element={<AuthedRoute Component={EquipmentContainer} />} />
              <Route path="/equipment/:equipmentid/:modelId" element={<AuthedRoute Component={EquipmentContainer} />} />
              <Route path="/equipmentFactory/:equipmentfactoryid" element={<AuthedRoute Component={EquipmentFactoryContainer} />} />
              <Route path="/equipmentFactory/:equipmentfactoryid/:modelId" element={<AuthedRoute Component={EquipmentFactoryContainer} />} />
              <Route path="/equipmentGroup/:type/:equipmentgroupid" element={<AuthedRoute Component={EquipmentGroupContainer} />} />
              <Route path="/equipmentGroup/:type/:equipmentgroupid/:modelId" element={<AuthedRoute Component={EquipmentGroupContainer} />} />
              <Route path="/leases" element={<AuthedRoute Component={LeaseList} />} />
              <Route path="/lease/new" element={<AuthedRoute Component={LeaseContainer} />} />
              <Route path="/lease/:leaseid" element={<AuthedRoute Component={LeaseContainer} />} />
              <Route path="/opengraph/new/:type/:targetId/:makeId" element={<AuthedRoute Component={OpenGraphContainer} />} />
              <Route path="/opengraph/new/:type/:targetId" element={<AuthedRoute Component={OpenGraphContainer} />} />
              <Route path="/opengraph/new/:makeId" element={<AuthedRoute Component={OpenGraphContainer} />} />
              <Route path="/opengraph/:type/:opengraphId" element={<AuthedRoute Component={OpenGraphContainer} />} />
              <Route path="/opengraph/:opengraphId" element={<AuthedRoute Component={OpenGraphContainer} />} />
              <Route path="/opengraph" element={<AuthedRoute Component={OpenGraphList} />} />
              <Route path="/farge/:colorId" element={<AuthedRoute Component={ColorContainer} />} />
              <Route path="/farge/:colorId/:modelId" element={<AuthedRoute Component={ColorContainer} />} />
              <Route path="/forhandlere" element={<AuthedRoute Component={DealerRegister} />} />
              <Route path="/forhandler/:dealerId" element={<AuthedRoute Component={DealerContainer} />} />
              <Route path="/merker" element={<AuthedRoute Component={MakesRegister} />} />
              <Route path="/merker/:makeId" element={<AuthedRoute Component={MakeContainer} />} />
              <Route path="/campaigns" element={<AuthedRoute Component={CampaignsContainer} />} />
              <Route path="/campaigns/new" element={<AuthedRoute Component={CampaignContainer} />} />
              <Route path="/campaigns/:campaignId" element={<AuthedRoute Component={CampaignContainer} />} />
              <Route path="/bilkonfigurator" element={<AuthedRoute Component={CarConfigurator} />} />
              <Route path="/nybilinformasjon" element={<AuthedRoute Component={NewCarInformation} />} />
              <Route path="/modeller/:makeid" element={<AuthedRoute Component={Models} />} />
              <Route path="/modeller/:makeId/modell/:id" element={<AuthedRoute Component={ModelContainer} />} />
              <Route path="/modeller/:makeId/modell/:modelId/side/:id" element={<AuthedRoute Component={ModelPageContainer} />} />
              <Route path="/modell/:id" element={<AuthedRoute Component={ModelContainer} />} />
              <Route path="/variant/:variantid" element={<AuthedRoute Component={VariantContainer} />} />
              <Route path="/variant/:variantid/:modelId" element={<AuthedRoute Component={VariantContainer} />} />
              <Route path="/variantgroup/:variantgroupid" element={<AuthedRoute Component={VariantGroupContainer} />} />
              <Route path="/variantgroup/:variantgroupid/:modelId" element={<AuthedRoute Component={VariantGroupContainer} />} />
              <Route path="/mypage" element={<AuthedRoute Component={CarInformation}/>} />
              <Route path="/mypage/:makeId" element={<AuthedRoute Component={GenerationModels}/>} />
              <Route path="/mypage/:makeId/generations/:id" element={<AuthedRoute Component={Generations}/>} />
              <Route path="/mypage/:makeId/generations/:id/new" element={<AuthedRoute Component={GenerationsContainer}/>} />
              <Route path="/mypage/:makeId/generations/:id/:gid" element={<AuthedRoute Component={GenerationsContainer}/>} />
              <Route path="/generation/:gid" element={<AuthedRoute Component={GenerationsContainer}/>} />
              <Route path="/mypage/access/:brand" element={<AuthedRoute Component={mypageAccess}/>} />
              <Route path="/articles" element={<AuthedRoute Component={ArticlesContainer}/>} />
              <Route path="/articles/new" element={<AuthedRoute Component={ArticleContainer}/>} />
              <Route path="/articles/new/:generationId" element={<AuthedRoute Component={ArticleContainer}/>} />
              <Route path="/articles/:articleId" element={<AuthedRoute Component={ArticleContainer}/>} />
              <Route path="/motorforum/campaigns" element={<AuthedRoute Component={MotorforumCampaignOverridesOverview}/>} />
              <Route path="/motorforum/campaigns/override/new" element={<AuthedRoute Component={MotorforumCampaignOverride}/>} />
              <Route path="/motorforum/campaigns/override/:id" element={<AuthedRoute Component={MotorforumCampaignOverride}/>} />
              <Route path="/motorforum/articles" element={<AuthedRoute Component={MotorforumArticlesContainer}/>} />
              <Route path="/motorforum/articles/new" element={<AuthedRoute Component={MotorforumArticleContainer}/>} />
              <Route path="/motorforum/articles/:articleId" element={<AuthedRoute Component={MotorforumArticleContainer}/>} />
              <Route path="/leads" element={<AuthedRoute Component={LeadsList} />} />
              <Route path="/leads/test" element={<AuthedRoute Component={LeadsTesting} />} />
              <Route path="/leads/lead/:leadId" element={<AuthedRoute Component={Lead} />} />
              <Route path="/reservations/mmc" key="mmc-reservations" element={<AuthedRoute Component={ReservationsList} />} />
              <Route path="/reservations/hbi" key="hbi-reservations" element={<AuthedRoute Component={ReservationsList} />} />
              <Route path="/reservations/:reservationId" element={<AuthedRoute Component={Reservation} />} />
              <Route path="/system" element={<AuthedRoute Component={SystemContainer} />} />
              <Route path="/giftcards" element={<AuthedRoute Component={GiftcardsList} />} />
              <Route path="/giftcards/new" element={<AuthedRoute Component={GiftcardContainer} />} />
              <Route path="/giftcards/:giftcardId" element={<AuthedRoute Component={GiftcardContainer} />} />
              <Route path="/warranties/:make" element={<AuthedRoute Component={WarrantyDocsList} />} />
              <Route path="/warranties/:make/:warrantyId" element={<AuthedRoute Component={WarrantyDocsContainer} />} />
              <Route path="/warrantyperiods/:make" element={<AuthedRoute Component={WarrantyPeriodList} />} />
              <Route path="/warrantyperiods/:make/:periodId" element={<AuthedRoute Component={WarrantyPeriodContainer} />} />
              <Route path="/warrantytest" element={<AuthedRoute Component={WarrantyPeriodTester} />} />
              <Route path="/leadSchemas" element={<AuthedRoute Component={LeadSchemasContainer} />} />
              <Route path="/leadSchemas/new" element={<AuthedRoute Component={LeadSchemaContainer} />} />
              <Route path="/leadSchemas/:schemaId" element={<AuthedRoute Component={LeadSchemaContainer} />} />

              <Route path="/cars-in-stock/:make" element={<AuthedRoute Component={StockList} />} />
              <Route path="/cars-in-stock/:make/:carId" element={<AuthedRoute Component={StockCarContainer} />} />
              <Route path="/media" element={<AuthedRoute Component={MediaBrowserList} />} />
              <Route path="/media/:mediaId" element={<AuthedRoute Component={MediaContainer} />} />
            </Routes>
          </TagProvider>
        </div>
      </div>
    </div>
  </BrowserRouter>
), document.getElementById('motorgruppen-app'));
